export const App = {
    // api: 'http://localhost/eusystem-backend/public/api/'
    api: 'https://service.eus.tech/api/',
    // api: 'http://192.168.1.5/eusystem-backend-upgrade/public/api/',
} 